<template>
  <div class="main" @click="loseFocus">
    <div class="part">
      <img src="../images/common/bg3.jpg" alt="" class="bg" />
      <div class="age">
        <img src="../images/common/age.png" alt="" />
      </div>

      <!-- 下载链接 -->
      <div class="app-load">
        <div class="secret mrn" @click="handleClick('app')">
          <a
            href="https://apps.apple.com/cn/app/%E6%88%BF%E9%97%B4%E7%9A%84%E7%A7%98%E5%AF%863-%E5%A5%B3%E5%9B%A2%E5%9B%9E%E5%BD%92%E5%A4%9C/id6446578284"
            target="_blank"
          >
            <img :src="getSrc(1)" alt="" class="load load1" />
          </a>
        </div>
        <div class="secret">
          <a>
            <img
              :src="getSrc(2)"
              alt=""
              class="load load1"
              @click="showDownloadList"
              data-name="android"
            />
            <ul v-if="downloadListVisible" class="download-list">
              <li v-for="item in downloadData" :key="item.url"  @click="handleClick(item.channel)">
                <a v-if="item.channel==='azgf'" :href="item.url"><img :src="item.iconUrl"/></a>
                <a v-else :href="item.url"  target="_blank"><img :src="item.iconUrl"/></a>
              </li>
            </ul>
          </a>
        </div>
      </div>
      <p class="text-tips">*PC版即将上线Steam平台</p>
    </div>
    <div class="footer">
      <img src="../images/common/footer.png" alt="" class="footer-bg" />
      <div class="logo logo1"></div>
      <div class="logo logo2"></div>
      <div class="line"></div>
      <div class="address">
        <div class="add-top">
          <div class="add-block">
            <a href="#" class="add-text" @click="handleOpen">联系我们</a>
            <div class="s-line"></div>
          </div>
          <div v-for="(item, index) in links" :key="index" class="add-block">
            <a class="add-text" target="_blank" :href="item.url">{{ item.name }}</a>
            <div class="s-line"></div>
          </div>
        </div>
        <div class="add-top">
          <div>投诉地址：ceo@dianchu.com投诉热线：18030296975</div>
        </div>
        <div class="add-top">
          <div>
            健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑
            沉迷游戏伤身 合理安排时间 享受健康生活
          </div>
        </div>
        <div class="add-top">
          <div>
            厦门皓月清风网络科技有限公司 ©2022 本公司旗下所运营游戏均适合16周岁以上人群
          </div>
        </div>
        <div class="add-top">
          <div>
            闽ICP备13010990号 ICP证：闽B2-20160006 闽网文[2018]6950-302号 闽公网安备35020302001590号
          </div>
        </div>
        <!-- <div class="add-bottom">
            
          </div> -->
      </div>
    </div>
    <div
      v-if="modalVisible"
      :class="['radioModal', { 'modal-bg': currentType !== 'radio' }]"
      v-fixed
    >
      <div class="radio-main">
        <div class="modal-close" @click="close">
          <img src="../images/common/close.png" alt="" />
        </div>
        <div>
          <div id="certify">
            <div>
              <div class="age-text modal-contact">
                <h2>联系我们</h2>
                <div class="main-block">
                  <div class="mess">
                    <div v-for="(item, index) in addList" :key="index" class="text">
                      {{ item }}
                    </div>
                  </div>
                  <img src="../images/common/cotact.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadData } from '../../config/common'
  export default {
    name: 'PcBanner',
    components: {},
    data() {
      return {
        modalVisible: false,
        downloadListVisible: false,
        downloadData,
        links: [
          {
            name: '法律声明',
            url: 'https://dc-app.9longe.net/hyqf/legalStatement.html',
          },
          {
            name: '纠纷处理',
            url: 'https://dc-app.9longe.net/hyqf/disputesSettlemen.html',
          },
          {
            name: '家长监护',
            url: 'https://dc-app.9longe.net/hyqf/parentProtect.html',
          },
          {
            name: '隐私政策',
            url: 'https://dc-tfc-hb2.9longe.net:30080/dc-update/audit/document/view?publisher=12564&game=1688&doc_type=privacy_policy&language_code=zh-cn',
          },
          {
            name: '儿童保护',
            url: 'https://dc-app.9longe.net/hyqf/child-protection.html',
          },
          {
            name: '用户协议',
            url: 'https://dc-app.9longe.net/hyqf/license.html',
          },
        ],
        addList: [
          '联系地址：厦门市软件园三期诚毅北大街62号109单元0786号',
          '联系电话：18030296975',
          '微博：NoFace工作室',
          'taptap：NoFace工作室',
          '微信公众号：NoFace工作室',
        ],
      }
    },
    methods: {
      getSrc(index) {
        return index === 2
          ? require(`../images/common/android3.png`)
          : require(`../images/common/appstore3.png`)
      },
      handleOpen() {
        this.modalVisible = true
      },
      close() {
        this.modalVisible = false
      },
      handleClick(channel) {
        // 埋点
        window.vizier.track_event('download', {
          channel,
          choose: 3,
        })
      },
      showDownloadList() {
        this.downloadListVisible = !this.downloadListVisible
      },
      loseFocus(e) {
        if (e.target.dataset.name !== 'android' && this.downloadListVisible) {
          this.downloadListVisible = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../css/common.less';
  .fun(@multiple) {
    .main {
      width: 100%;
      height: 100%;
      overflow: auto;
      .part {
        position: relative;
        .bg {
          width: 100%;
          height: 100%;
          display: block;
        }
        .age {
          position: absolute;
          cursor: pointer;
          width: 82px * @multiple;
          height: 108px * @multiple;
          top: 37px * @multiple;
          right: 38px * @multiple;
          z-index: 100;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .app-load {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 67px * @multiple;
        width: 100%;
        &:hover {
          cursor: pointer;
        }
        .load {
          width: 336px * @multiple;
          height: 80px * @multiple;
          background-size: cover !important;
        }
        .mrn {
          margin-right: 100px * @multiple;
        }
        a {
          position: relative;
          .download-list {
            padding: 0;
            margin: 0;
            list-style: none;
            position: absolute;
            bottom: 88px;
            width: 358px * @multiple;
            height: 426px * @multiple;
            background: url(../images/common/download-list-bg.png);
            li {
              margin-top: 16px;
              cursor: pointer;
              img {
                width: 336px * @multiple;
                height: 80px * @multiple;
              }
            }
          }
        }
      }
      .text-tips {
        width: 100%;
        position: absolute;
        bottom: 0;
        color: #ffffff;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
      }
      .footer {
        // padding-top: 45px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 16px * @multiple;
        position: relative;
        box-sizing: border-box;
        .footer-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          display: block;
          z-index: -1;
        }
        .logo {
          margin-right: 25px * @multiple;
          background-size: cover !important;
        }
        .logo1 {
          width: 192px * @multiple;
          height: 76px * @multiple;
          background: url(../images/common/logo-1.png) no-repeat center;
          margin-right: 40px * @multiple;
        }
        .logo2 {
          width: 175px * @multiple;
          height: 76px * @multiple;
          background: url(../images/common/logo-2.png) no-repeat center;
          margin-right: 80px * @multiple;
        }
        .line {
          height: 160px * @multiple;
          border-right: 0.1px solid #fff;
          opacity: 0.5;
        }
        .address {
          margin-left: 91px;
          .add-top {
            display: flex;
            align-items: center;
            margin-bottom: 15px * @multiple;
            .add-block {
              display: flex;
              margin-left: 15px;
            }
            .add-block:first-child {
              margin-left: 0;
            }
            .add-block:last-child .s-line {
              display: none;
            }
            .s-line {
              width: 15px;
              margin-top: 5px;
              height: 15px;
              border-right: 1px solid #fff;
            }
            a {
              color: #fff;
              cursor: pointer;
              text-decoration: none;
            }
          }
        }
        .description {
          .des-row {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
          }
          .des-block {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 100%;
            background: #8b8ba6;
          }
          .des-text {
            width: 634px * @multiple;
          }
        }
      }

      .radioModal {
        position: fixed;
        z-index: 100;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.8);
        .radio-main {
          position: relative;
          height: 100%;
          .radios {
            position: absolute;
            width: 1000px * @multiple;
            height: 500px * @multiple;
            top: 50%;
            left: 50%;
            margin-left: -500px;
            margin-top: -250px * @multiple;
          }
        }
        .modal-close {
          color: #fff;
          position: absolute;
          z-index: 10000000;
          right: 0;
          padding: 25px * @multiple 30px * @multiple;
          font-size: 40px * @multiple;
          &:hover {
            cursor: pointer;
          }
        }
        #certify {
          position: absolute;
          width: 1200px * @multiple;
          height: 505px * @multiple;
          top: 50%;
          left: 50%;
          margin-left: -600px * @multiple;
          margin-top: -252px * @multiple;
        }
      }

      .age-text {
        width: 800px;
        height: 560px;
        overflow: auto;
        margin: 0 auto;
        padding: 30px;
        background: bisque;
        color: #222;
        // border: 1px solid #ccc;
        border-radius: 8px;
        font-size: 18px;
        line-height: 28px;
        margin-top: -100px * @multiple;
        h2 {
          text-align: center;
        }
      }
      .modal-contact {
        margin-top: 0px * @multiple;
        height: 400px;
        color: #222;
        .main-block {
          display: flex;
          justify-content: space-around;
          align-items: center;
          .mess {
            .text {
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 1200px) {
    .main {
      min-width: 1032px;
    }
  }
  @media (max-width: 1350px) {
    .fun(0.6);
  }
  @media (max-width: 1500px) and(min-width: 1351px) {
    .fun(0.7);
  }
  @media (min-width: 1500px) {
    .fun(1);
  }
  .show {
    display: block !important;
  }
</style>
